import React, { useContext, useRef } from 'react';
import { VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { OpacitySlider } from '@/components/opacity-slider';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { VectorPanelContext } from '../../context';
import { Tracker } from '../../utils';

export const LayerOpacity: React.FC = () => {
    const { layerId, recordId } = useContext(VectorPanelContext)!;

    const editor = useEditor();
    const layer = editor.stage.getLayer(layerId);
    const opacity = layer ? layer.opacity : 1;

    const prevOpacityRef = useRef(opacity);

    const curOpacity = useListenActivePickLayerProps(editor, (layer) => {
        return layer ? layer.opacity : 1;
    }) as number;

    const layerOpacity = ~~(curOpacity * 100);

    const handleChange = (value: number) => {
        editor.getInstance(VectorLayer).setOpacity(layerId, value / 100);
    };

    const handleAfterChange = (value: number) => {
        editor.getInstance(VectorLayer).setOpacity(layerId, value / 100, prevOpacityRef.current);
        prevOpacityRef.current = value / 100;

        Tracker.setLayerOpacity({
            recordId,
            stageType: editor.stage.getType(),
        });
    };

    return (
        <OpacitySlider layout="stack" value={layerOpacity} onChange={handleChange} onAfterChange={handleAfterChange} />
    );
};
